import { api } from './client';

export interface KeywordSuggestion {
  keyword: string;
  trendScore?: number;
  sourceAttribution?: string;
}

export interface TrendPoint {
  date: string;
  score?: number;
  interest?: number;
}

export interface SeedMetrics {
  inTopTrends: boolean;
  rank: number | null;
  rankOutOf: number | null;
  pctGrowthWow: number | null;
  pctGrowthMom: number | null;
  pctGrowthYoy: number | null;
  /** 0-100 popularity relative to the top keyword in this result set. */
  relativeIndex: number | null;
  monthlyVolume: number | null;
  volumeSource: string | null;
}

export interface KeywordRow {
  keyword: string;
  /**
   * 0-100 popularity relative to the top keyword in this result set (top = 100).
   * This is the headline number: Pinterest publishes no per-keyword search volume,
   * so the relative shape is the only defensible signal.
   */
  relativeIndex: number | null;
  /** Absolute monthly searches — null unless the backend has a real volume anchor. */
  monthlyVolume: number | null;
  trendScorePct: number | null;
  sourceAttribution: string;
}

export interface KeywordResearchResult {
  seed: string;
  region: string;
  seedMetrics: SeedMetrics;
  timeSeries: TrendPoint[];
  rows: KeywordRow[];
  relatedKeywords: KeywordSuggestion[];
  topTrendingInRegion: KeywordSuggestion[];
  sources: string[];
}

export function searchKeyword(
  { q, region }: { q: string; region: string },
  token: string | null,
): Promise<KeywordResearchResult> {
  const params = new URLSearchParams({ q, region });
  return api.get<KeywordResearchResult>(`/keyword-explorer/search?${params.toString()}`, token);
}

export interface SavedKeyword {
  id: string;
  keyword: string;
  folder: string | null;
  tags: string[];
  estimatedVolume: number | null;
  source: string;
  createdAt: string;
}

export function saveKeyword(
  input: { keyword: string; folder?: string; tags?: string[]; source?: string },
  token: string | null,
): Promise<SavedKeyword> {
  return api.post<SavedKeyword>('/saved-keywords', input, token);
}
